import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAATUlEQVR42m2MQQqAMAwE+/8vefJeLehV/2C1oUkaWEGwFNo9DcswDs04E5ipvcz9JFowzR5rWGBWeiFRht9OhP34eFBQxDvhig9EtAovENR8OIvSC5MAAAAASUVORK5CYII="};
